import { types } from "mobx-state-tree"
import { REQUEST_STATUSES } from "~/utilities/constants"


const Network = types
  .model("NetworkStore", {
    networkStatus: types.optional(
      types.enumeration(Object.keys(REQUEST_STATUSES)),
      REQUEST_STATUSES.init
    ),
    networkError: types.maybeNull(types.string)
  })
  .views(self => ({
    get isInit() {
      return self.networkStatus === REQUEST_STATUSES.init
    },
    get isLoading() {
      return self.networkStatus === REQUEST_STATUSES.loading
    },
    get isError() {
      return self.networkStatus === REQUEST_STATUSES.error
    },
    get isComplete() {
      return self.networkStatus === REQUEST_STATUSES.complete
    },
    get error() {
      return self.networkError
    }
  }))
  .actions(self => ({
    requestReset() {
      self.networkError = null
      self.networkStatus = REQUEST_STATUSES.init
    },
    requestStart() {
      self.networkError = null
      self.networkStatus = REQUEST_STATUSES.loading
    },
    requestComplete() {
      self.networkError = null
      self.networkStatus = REQUEST_STATUSES.complete
    },
    requestError(error) {
      let errorToSave
      if (process.env.WINIT_ENV !== "test") {
        console.error("Error network:", error)
      }
      if (typeof error === "string") {
        errorToSave = error
      } else if (error.message && typeof error.message === "string") {
        errorToSave = error.message
      } else {
        errorToSave = "Something went wrong."
      }
      self.networkError = errorToSave
      self.networkStatus = REQUEST_STATUSES.error
    }
  }))

export default Network
